var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarginBottomLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_60_117)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    transform: "translate(196 98) rotate(180)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 46,
    width: 180,
    height: 55,
    rx: 5,
    transform: "rotate(180 188 46)",
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 46,
    width: 180,
    height: 55,
    rx: 5,
    transform: "rotate(180 188 46)",
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.6464 79.3536C97.8417 79.5488 98.1583 79.5488 98.3536 79.3536L101.536 76.1716C101.731 75.9763 101.731 75.6597 101.536 75.4645C101.34 75.2692 101.024 75.2692 100.828 75.4645L98 78.2929L95.1716 75.4645C94.9763 75.2692 94.6597 75.2692 94.4645 75.4645C94.2692 75.6597 94.2692 75.9763 94.4645 76.1716L97.6464 79.3536ZM98.3536 53.6464C98.1583 53.4512 97.8417 53.4512 97.6464 53.6464L94.4645 56.8284C94.2692 57.0237 94.2692 57.3403 94.4645 57.5355C94.6597 57.7308 94.9763 57.7308 95.1716 57.5355L98 54.7071L100.828 57.5355C101.024 57.7308 101.34 57.7308 101.536 57.5355C101.731 57.3403 101.731 57.0237 101.536 56.8284L98.3536 53.6464ZM98.5 79L98.5 54L97.5 54L97.5 79L98.5 79Z",
    fill: "#007FFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 144,
    width: 180,
    height: 58,
    rx: 5,
    transform: "rotate(180 188 144)",
    fill: "#64748B",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 144,
    width: 180,
    height: 58,
    rx: 5,
    transform: "rotate(180 188 144)",
    stroke: "#64748B",
    strokeDasharray: "4 4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_60_117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white",
    transform: "translate(196 98) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarginBottomLg);
export default __webpack_public_path__ + "static/media/margin_bottom_lg.5769d6b92c1cf0d4cbf27d7e521d718f.svg";
export { ForwardRef as ReactComponent };